module.exports = __webpack_public_path__ + "9ca297f5527045c2d49d7f8343339c8d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/modern-mansion.png
// module id = 583
// module chunks = 0